import ImageProps, { ImageLayerProps, LayerAreaSelection } from "../imageStudio/images";

export const stateIconError =  '❌';
export const stateIconDone = '✅';
export const stateIconSend = '⇄';
export const stateIconWaiting = '⏳';

export type aiStateTypes = 'done' | 'waiting' | 'error' | 'send' | null;

export type AiSelectionContext = {
    sourceType: "base" | "layer";
    selection: LayerAreaSelection;
    sourceImage: ImageProps | ImageLayerProps;
    sourceLayerGeometry: {
        position: { x: number; y: number };
        width: number;
        height: number;
        rotation: number;
    };
};